<template>
  <div class="color-sample n1-east">
    <section>
      <p class="small-text">
        享年 八十八歳
      </p>
    </section>
    <section>
      <p class="default-text">
        俗名 源頼朝
      </p>
    </section>
    <section />
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-back.scss";
</style>
